
      const customCSSPropertiesMap = {
        "maxContentWidth": "--awsui-max-content-width-4hh3rt",
"minContentWidth": "--awsui-min-content-width-4hh3rt",
"breadcrumbsGap": "--awsui-breadcrumbs-gap-4hh3rt",
"contentGapLeft": "--awsui-content-gap-left-4hh3rt",
"contentGapRight": "--awsui-content-gap-right-4hh3rt",
"contentHeight": "--awsui-content-height-4hh3rt",
"contentLayoutDefaultHorizontalPadding": "--awsui-content-layout-default-horizontal-padding-4hh3rt",
"contentLayoutMaxContentWidth": "--awsui-content-layout-max-content-width-4hh3rt",
"contentLayoutMainGap": "--awsui-content-layout-main-gap-4hh3rt",
"defaultMaxContentWidth": "--awsui-default-max-content-width-4hh3rt",
"defaultMinContentWidth": "--awsui-default-min-content-width-4hh3rt",
"drawerSize": "--awsui-drawer-size-4hh3rt",
"drawerMinSize": "--awsui-drawer-min-size-4hh3rt",
"bottomDrawerSize": "--awsui-bottom-drawer-size-4hh3rt",
"footerHeight": "--awsui-footer-height-4hh3rt",
"headerGap": "--awsui-header-gap-4hh3rt",
"headerHeight": "--awsui-header-height-4hh3rt",
"layoutWidth": "--awsui-layout-width-4hh3rt",
"mainGap": "--awsui-main-gap-4hh3rt",
"mainOffsetLeft": "--awsui-main-offset-left-4hh3rt",
"mainTemplateRows": "--awsui-main-template-rows-4hh3rt",
"mobileBarHeight": "--awsui-mobile-bar-height-4hh3rt",
"notificationsHeight": "--awsui-notifications-height-4hh3rt",
"offsetTop": "--awsui-offset-top-4hh3rt",
"overlapHeight": "--awsui-overlap-height-4hh3rt",
"navigationWidth": "--awsui-navigation-width-4hh3rt",
"splitPanelReportedHeaderSize": "--awsui-split-panel-reported-header-size-4hh3rt",
"splitPanelReportedSize": "--awsui-split-panel-reported-size-4hh3rt",
"splitPanelHeight": "--awsui-split-panel-height-4hh3rt",
"splitPanelMinWidth": "--awsui-split-panel-min-width-4hh3rt",
"splitPanelMaxWidth": "--awsui-split-panel-max-width-4hh3rt",
"toolsMaxWidth": "--awsui-tools-max-width-4hh3rt",
"toolsWidth": "--awsui-tools-width-4hh3rt",
"toolsAnimationStartingOpacity": "--awsui-tools-animation-starting-opacity-4hh3rt",
"contentScrollMargin": "--awsui-content-scroll-margin-4hh3rt",
"flashbarStackDepth": "--awsui-flashbar-stack-depth-4hh3rt",
"flashbarStackIndex": "--awsui-flashbar-stack-index-4hh3rt",
"flashbarStickyBottomMargin": "--awsui-flashbar-sticky-bottom-margin-4hh3rt",
"stackedNotificationsBottomMargin": "--awsui-stacked-notifications-bottom-margin-4hh3rt",
"stackedNotificationsDefaultBottomMargin": "--awsui-stacked-notifications-default-bottom-margin-4hh3rt",
"dropdownDefaultMaxWidth": "--awsui-dropdown-default-max-width-4hh3rt",
"spinnerRotatorFrom": "--awsui-spinner-rotator-from-4hh3rt",
"spinnerRotatorTo": "--awsui-spinner-rotator-to-4hh3rt",
"spinnerLineLeftFrom": "--awsui-spinner-line-left-from-4hh3rt",
"spinnerLineLeftTo": "--awsui-spinner-line-left-to-4hh3rt",
"spinnerLineRightFrom": "--awsui-spinner-line-right-from-4hh3rt",
"spinnerLineRightTo": "--awsui-spinner-line-right-to-4hh3rt",
"sliderLabelCount": "--awsui-slider-label-count-4hh3rt",
"sliderTickCount": "--awsui-slider-tick-count-4hh3rt",
"sliderReferenceColumn": "--awsui-slider-reference-column-4hh3rt",
"sliderNextReferenceColumn": "--awsui-slider-next-reference-column-4hh3rt",
"sliderMaxStart": "--awsui-slider-max-start-4hh3rt",
"sliderMinEnd": "--awsui-slider-min-end-4hh3rt",
"sliderRangeInlineSize": "--awsui-slider-range-inline-size-4hh3rt",
"sliderTooltipPosition": "--awsui-slider-tooltip-position-4hh3rt",
"togglesLeftWidth": "--awsui-toggles-left-width-4hh3rt",
"togglesRightWidth": "--awsui-toggles-right-width-4hh3rt",
"promptInputMaxRows": "--awsui-prompt-input-max-rows-4hh3rt",
"promptInputScrollHeight": "--awsui-prompt-input-scroll-height-4hh3rt",
"dragHandleAnimationInlineOffset": "--awsui-drag-handle-animation-inline-offset-4hh3rt",
"dragHandleAnimationBlockOffset": "--awsui-drag-handle-animation-block-offset-4hh3rt",
"styleBackgroundActive": "--awsui-style-background-active-4hh3rt",
"styleBackgroundDefault": "--awsui-style-background-default-4hh3rt",
"styleBackgroundDisabled": "--awsui-style-background-disabled-4hh3rt",
"styleBackgroundHover": "--awsui-style-background-hover-4hh3rt",
"styleBorderColorActive": "--awsui-style-border-color-active-4hh3rt",
"styleBorderColorDefault": "--awsui-style-border-color-default-4hh3rt",
"styleBorderColorDisabled": "--awsui-style-border-color-disabled-4hh3rt",
"styleBorderColorHover": "--awsui-style-border-color-hover-4hh3rt",
"styleColorActive": "--awsui-style-color-active-4hh3rt",
"styleColorDefault": "--awsui-style-color-default-4hh3rt",
"styleColorDisabled": "--awsui-style-color-disabled-4hh3rt",
"styleColorHover": "--awsui-style-color-hover-4hh3rt",
"styleFocusRingBorderColor": "--awsui-style-focus-ring-border-color-4hh3rt",
"styleFocusRingBorderRadius": "--awsui-style-focus-ring-border-radius-4hh3rt",
"styleFocusRingBorderWidth": "--awsui-style-focus-ring-border-width-4hh3rt",
"styleFocusRingBoxShadow": "--awsui-style-focus-ring-box-shadow-4hh3rt",
"styleBoxShadowActive": "--awsui-style-box-shadow-active-4hh3rt",
"styleBoxShadowDefault": "--awsui-style-box-shadow-default-4hh3rt",
"styleBoxShadowDisabled": "--awsui-style-box-shadow-disabled-4hh3rt",
"styleBoxShadowHover": "--awsui-style-box-shadow-hover-4hh3rt",
"styleBackgroundReadonly": "--awsui-style-background-readonly-4hh3rt",
"styleBorderColorReadonly": "--awsui-style-border-color-readonly-4hh3rt",
"styleBoxShadowReadonly": "--awsui-style-box-shadow-readonly-4hh3rt",
"styleColorReadonly": "--awsui-style-color-readonly-4hh3rt",
"styleBackgroundFocus": "--awsui-style-background-focus-4hh3rt",
"styleBorderColorFocus": "--awsui-style-border-color-focus-4hh3rt",
"styleBoxShadowFocus": "--awsui-style-box-shadow-focus-4hh3rt",
"styleColorFocus": "--awsui-style-color-focus-4hh3rt",
"stylePlaceholderColor": "--awsui-style-placeholder-color-4hh3rt",
"stylePlaceholderFontSize": "--awsui-style-placeholder-font-size-4hh3rt",
"stylePlaceholderFontStyle": "--awsui-style-placeholder-font-style-4hh3rt",
"stylePlaceholderFontWeight": "--awsui-style-placeholder-font-weight-4hh3rt",
"styleTabsActiveIndicatorColor": "--awsui-style-tabs-active-indicator-color-4hh3rt",
"styleTabsActiveIndicatorWidth": "--awsui-style-tabs-active-indicator-width-4hh3rt",
"styleTabsActiveIndicatorBorderRadius": "--awsui-style-tabs-active-indicator-border-radius-4hh3rt",
"styleTabsSeparatorColor": "--awsui-style-tabs-separator-color-4hh3rt",
"styleTabsSeparatorWidth": "--awsui-style-tabs-separator-width-4hh3rt",
"alertFocusRingBorderColor": "--awsui-alert-focus-ring-border-color-4hh3rt",
"alertFocusRingBorderRadius": "--awsui-alert-focus-ring-border-radius-4hh3rt",
"alertFocusRingBorderWidth": "--awsui-alert-focus-ring-border-width-4hh3rt",
"alertFocusRingBoxShadow": "--awsui-alert-focus-ring-box-shadow-4hh3rt",
"alertIconColor": "--awsui-alert-icon-color-4hh3rt",
"promptInputStyleBackgroundDefault": "--awsui-prompt-input-style-background-default-4hh3rt",
"promptInputStyleBackgroundDisabled": "--awsui-prompt-input-style-background-disabled-4hh3rt",
"promptInputStyleBackgroundFocus": "--awsui-prompt-input-style-background-focus-4hh3rt",
"promptInputStyleBackgroundHover": "--awsui-prompt-input-style-background-hover-4hh3rt",
"promptInputStyleBackgroundReadonly": "--awsui-prompt-input-style-background-readonly-4hh3rt",
"promptInputStyleBorderColorDefault": "--awsui-prompt-input-style-border-color-default-4hh3rt",
"promptInputStyleBorderColorDisabled": "--awsui-prompt-input-style-border-color-disabled-4hh3rt",
"promptInputStyleBorderColorFocus": "--awsui-prompt-input-style-border-color-focus-4hh3rt",
"promptInputStyleBorderColorHover": "--awsui-prompt-input-style-border-color-hover-4hh3rt",
"promptInputStyleBorderColorReadonly": "--awsui-prompt-input-style-border-color-readonly-4hh3rt",
"promptInputStyleBoxShadowDefault": "--awsui-prompt-input-style-box-shadow-default-4hh3rt",
"promptInputStyleBoxShadowDisabled": "--awsui-prompt-input-style-box-shadow-disabled-4hh3rt",
"promptInputStyleBoxShadowFocus": "--awsui-prompt-input-style-box-shadow-focus-4hh3rt",
"promptInputStyleBoxShadowHover": "--awsui-prompt-input-style-box-shadow-hover-4hh3rt",
"promptInputStyleBoxShadowReadonly": "--awsui-prompt-input-style-box-shadow-readonly-4hh3rt",
"promptInputStyleColorDefault": "--awsui-prompt-input-style-color-default-4hh3rt",
"promptInputStyleColorDisabled": "--awsui-prompt-input-style-color-disabled-4hh3rt",
"promptInputStyleColorFocus": "--awsui-prompt-input-style-color-focus-4hh3rt",
"promptInputStyleColorHover": "--awsui-prompt-input-style-color-hover-4hh3rt",
"promptInputStyleColorReadonly": "--awsui-prompt-input-style-color-readonly-4hh3rt",
"promptInputStylePlaceholderColor": "--awsui-prompt-input-style-placeholder-color-4hh3rt",
"promptInputStylePlaceholderFontSize": "--awsui-prompt-input-style-placeholder-font-size-4hh3rt",
"promptInputStylePlaceholderFontStyle": "--awsui-prompt-input-style-placeholder-font-style-4hh3rt",
"promptInputStylePlaceholderFontWeight": "--awsui-prompt-input-style-placeholder-font-weight-4hh3rt",
"progressBarBackgroundColor": "--awsui-progress-bar-background-color-4hh3rt",
"progressBarBorderRadius": "--awsui-progress-bar-border-radius-4hh3rt",
"progressBarHeight": "--awsui-progress-bar-height-4hh3rt",
"progressValueBackgroundColor": "--awsui-progress-value-background-color-4hh3rt",
"styleSliderTrackBackgroundColor": "--awsui-style-slider-track-background-color-4hh3rt",
"styleSliderRangeBackgroundDefault": "--awsui-style-slider-range-background-default-4hh3rt",
"styleSliderRangeBackgroundActive": "--awsui-style-slider-range-background-active-4hh3rt",
"styleSliderHandleBackgroundDefault": "--awsui-style-slider-handle-background-default-4hh3rt",
"styleSliderHandleBackgroundHover": "--awsui-style-slider-handle-background-hover-4hh3rt",
"styleSliderHandleBackgroundActive": "--awsui-style-slider-handle-background-active-4hh3rt",
"styleSliderHandleBorderRadius": "--awsui-style-slider-handle-border-radius-4hh3rt",
      };
      export default customCSSPropertiesMap;
    